/*
 * Parc Fermé — Race Rewards© live balance for the header chip (window.pfRewards.get()).
 * 2026-10-04 rebuild: reads Yotpo Loyalty's storefront SDK directly (window.swellAPI.getCustomerDetails()),
 * verified live on cmcmotorsports.com for logged-in customers. Replaces the old approach that mounted a hidden
 * Yotpo widget (instance 623884) and scraped its text.
 * Resolves { points, tier } or { points: null, tier: null } after 15s / for guests; consumers stay hidden then.
 */
(function () {
  var TIMEOUT_MS = 15000, POLL_MS = 300, cached = null;
  function read() {
    var api = window.swellAPI;
    if (!api || typeof api.getCustomerDetails !== 'function') return null;
    var cd = api.getCustomerDetails();
    // Before Yotpo identifies the logged-in customer it returns placeholder details with pointsBalance 0 and no
    // email; reading then showed "0 PTS" (2026-10-04). Wait for the identified record.
    if (!cd || cd.pointsBalance == null || !cd.email) return null;
    var tier = cd.vipTier && cd.vipTier.name && cd.vipTier.name !== 'null' ? cd.vipTier.name : null;
    return { points: Number(cd.pointsBalance) || 0, tier: tier };
  }
  function loggedIn() {
    return !!document.getElementById('swell-customer-identification') || !!(window.customerData && window.customerData.id);
  }
  window.pfRewards = {
    get: function () {
      if (cached) return cached;
      cached = new Promise(function (resolve) {
        var done = function (r) { try { document.dispatchEvent(new CustomEvent('pf:rewards', { detail: r })); } catch (e) {} resolve(r); };
        if (!loggedIn()) { done({ points: null, tier: null }); return; }
        var t0 = Date.now();
        (function poll() {
          var r = read();
          if (r) {
            // Keep the chip current after redemptions or late Yotpo refreshes.
            document.addEventListener('swell:customer:updated', function () {
              var u = read();
              if (u) { try { document.dispatchEvent(new CustomEvent('pf:rewards', { detail: u })); } catch (e) {} }
            });
            return done(r);
          }
          if (Date.now() - t0 > TIMEOUT_MS) return done({ points: null, tier: null });
          setTimeout(poll, POLL_MS);
        })();
      });
      return cached;
    }
  };
})();
